<template lang="pug">
  //- NOTE
  //- * everything em based for compatibility/sizing on laravel :(
  header.app-header(:class="[`text-${ui}`]")
    //- title
    .fixed.z-30.top-0.left-0
      .mt-4.ml-6.text-11.md-text-13.leading-lg
        router-link.hover-text-blue.trans-color-fast(:to="{name: 'home'}") Blue Mountain School
    //- menu / cart / shop filters btns
    mobile-bottom-menu.z-50.md-w-auto.md-top-0.md-bottom-auto.md-mt-12e.md-pr-30e(v-show="menuBtn")
      //- menu btn
      button.block.pointer-events-auto.px-10.-mx-10.md-px-0.md-mx-0(slot="center", aria-label="Toggle Site Menu", @click="menu = !menu")
        .w-40.h-40.relative.text-black.md-text-inherit.flex.items-center.justify-center.pointer-events-auto.border.border-gray-300.rounded-full.md-bg-transp.md-border-none.focus-text-blue.active-text-blue(:class="{'bg-gray-100': !isLib, 'bg-white-a95': isLib}")
          menu-icon.app-header__menu-icon.block.absolute.inset-0.h-full.w-full
      //- cart / btn
      cart(slot="left")
    //- menu overlay
    transition(name="overlaymenu", v-on:after-enter="lockScroll(true)", v-on:before-leave="lockScroll(false)")
      //- overlay
      overlay-menu.fixed.z-40(v-show="menu", v-if="site", @close="menu = false", :bg="isLib ? 'bg-white' : 'bg-gray-100'",)
        nav.md-h-screen.flex.flex-col.items-center.justify-between.pt-164e.md-pt-0
          //- top group
          ul.mt-60e.md-mt-30e.list-reset.md-flex.md-justify-center.w-full.text-left.md-text-center
            li.mx-10e.md-mx-6e.leading-none.border-t.md-border-none.px-20e.md-px-0(style="min-width:17em", v-for="(item, i) in site.menu_secondary", :class="{'border-b': i === site.menu_secondary.length - 1}")
              wp-link.inline-block.hover-text-blue.trans-color-fast(:link="item.link", linkClss="h-60e md-h-0 flex items-center")
                span.text-15.md-text-13 {{ item.link.title }}
          //- main group
          ul.nav__spaces.order-first.md-order-none.w-full.md-px-10e.lg-px-40e.md-flex.justify-center.md-list-reset
            //- groups
            li.mx-10e.md-mx-6e.flex-1.md-pb-15(v-for="(grp, i) in site.menu", @click="toggleGrp(i)")
              //- parent
              .flex.items-center.md-justify-center.border-t.md-border-none.px-20e.md-px-0
                wp-link.inline-block.hover-text-blue.trans-color-fast.whitespace-no-wrap.pointer-events-none.md-pointer-events-auto(:link="grp.parent", linkClss="h-60e md-h-0 flex items-center md-inline")
                  span.text-18.md-text-24 {{ grp.parent.title }}
              //- children
              ul.relative.trans-opacity-quick(v-show="mblGrpsOpen.includes(i) || winIs('md')", style="margin-left:0 !important")
                .md-absolute.w-full.text-left.md-text-center
                  //- ("overview" link - mobile)
                  li.border-t.md-hidden(v-if="!grp.parent.url.includes('blue-projects')")
                    wp-link.block(:link="grp.parent", linkClss="h-60e md-h-0 pl-50e md-pl-0 flex items-center md-inline")
                      span.text-15 Overview
                  //- items
                  li.border-t.md-border-none.truncate(v-for="child in grp.items")
                    wp-link.block.w-full.md-inline.md-w-auto.hover-text-blue.trans-color-fast(:link="child.link", linkClss="h-60e md-h-0 pl-50e md-pl-0 flex w-full items-center md-inline md-w-auto")
                      span.text-15.md-text-24 {{ child.link.title }}
            .mx-10e.border-b.md-hidden
          //- social
          social-btns.w-full.pt-30e.pb-ios.md-pt-0.md-pb-20e(:account="true")

    library-categories-menu(v-if="isLib", @mblMenu="menuBtn = !$event", :hideBtn="menu")
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import WpLink from '@/components/WPLink'
import SocialBtns from '@/components/SocialBtns'
import MenuIcon from '@/components/Icons/MenuIcon'
import svgX from '@/components/Icons/SVG-X'
import LibraryCategoriesMenu from '@/components/LibraryCategoriesMenu'
import Cart from '@/components/Cart/Cart'
export default {
  name: 'AppHeader',
  props: ['isLib'],
  data () {
    return {
      menu: false,
      mblGrpsOpen: [],
      menuBtn: true,
      lastUI: null
    }
  },
  computed: {
    ...mapState(['ui', 'site', 'subscribe']),
    ...mapGetters(['winIs'])
  },
  methods: {
    ...mapMutations(['lockScroll']),
    bindLinks () {
      this.$el.querySelectorAll('a').forEach(el => el.addEventListener('click', () => {
        this.menu = false
      }))
    },
    toggleGrp (i) {
      // open
      if (!this.mblGrpsOpen.includes(i)) return this.mblGrpsOpen.push(i)
      // close
      const pos = this.mblGrpsOpen.indexOf(i)
      this.mblGrpsOpen.splice(pos, 1)
    }
  },
  watch: {
    '$route' () {
      this.menu = false
    },
    menu (vis) {
      if (!vis) return this.$store.commit('SET_UI', this.lastUI)
      // save ui color
      this.lastUI = this.$store.state.ui
      this.$store.commit('SET_UI') // black ui
    },
    subscribe () {
      setTimeout(() => { this.menu = false }, 600)
    }
  },
  mounted () {
    this.bindLinks()
  },
  components: { MenuIcon, WpLink, SocialBtns, svgX, LibraryCategoriesMenu, Cart }
}
</script>

<style>
@import '../style/_settings.css';

/* laptop hover - hide/show submenus */
@media (hover: hover) and (--bkpt-md) {
  .nav__spaces{
    & > li{
      & > ul{
        opacity: 0;
      }
      &:hover > ul{
        opacity:1;
      }
    }
  }
}

</style>
